import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "scrollerLoader",
  class: "scroller__loading"
}
const _hoisted_2 = ["data-date-timestamp"]
const _hoisted_3 = {
  key: 0,
  class: "scroller__loading-new"
}
const _hoisted_4 = { class: "scroller__loading-new-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingPlaceholder = _resolveComponent("LoadingPlaceholder")
  const _component_IconMessageOutline = _resolveComponent("IconMessageOutline")
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_StaticDateTime = _resolveComponent("StaticDateTime")

  return (_openBlock(), _createElementBlock("div", {
    ref: "scroller",
    class: _normalizeClass(["scroller messages-list__scroller", {
			'scroller--chatScrolledToBottom': $props.isChatScrolledToBottom,
			'scroller--isScrolling': $data.isScrolling,
		}]),
    onScroll: _cache[0] || (_cache[0] = (...args) => ($options.onScroll && $options.onScroll(...args))),
    onScrollend: _cache[1] || (_cache[1] = (...args) => ($options.endScroll && $options.endScroll(...args)))
  }, [
    ($setup.isInitialisingMessages)
      ? (_openBlock(), _createBlock(_component_LoadingPlaceholder, {
          key: 0,
          type: "messages",
          class: "messages-list__placeholder",
          count: 15
        }))
      : ($options.showEmptyContent)
        ? (_openBlock(), _createBlock(_component_NcEmptyContent, {
            key: 1,
            class: "messages-list__empty-content",
            name: $options.t('spreed', 'No messages'),
            description: $options.t('spreed', 'All messages have expired or have been deleted.')
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconMessageOutline, { size: 64 })
            ]),
            _: 1
          }, 8, ["name", "description"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_TransitionWrapper, { name: "fade" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  ($setup.loadingOldMessages)
                    ? (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                        key: 0,
                        class: "scroller__loading-element",
                        size: 32
                      }))
                    : _createCommentVNode("", true)
                ], 512)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messagesGroupedByDateByAuthor, (list, dateTimestamp) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: `section_${dateTimestamp}`,
                ref_for: true,
                ref: `dateGroup-${$props.token}`,
                "data-date-timestamp": dateTimestamp,
                class: _normalizeClass(["scroller__content", { 'has-sticky': dateTimestamp === $data.stickyDate }])
              }, [
                (_openBlock(), _createElementBlock("li", {
                  key: `${$options.currentDay}_${dateTimestamp}`,
                  class: "messages-date"
                }, [
                  _createVNode(_component_StaticDateTime, {
                    time: dateTimestamp * 1000,
                    class: "messages-date__text",
                    role: "heading",
                    "aria-level": "3"
                  }, null, 8, ["time"])
                ])),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (group) => {
                  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.messagesGroupComponent[group.type]), {
                    key: group.id,
                    token: $props.token,
                    messages: group.messages,
                    "previous-message-id": group.previousMessageId,
                    "next-message-id": group.nextMessageId
                  }, null, 8, ["token", "messages", "previous-message-id", "next-message-id"]))
                }), 128))
              ], 10, _hoisted_2))
            }), 128)),
            _createVNode(_component_TransitionWrapper, { name: "fade" }, {
              default: _withCtx(() => [
                ($setup.loadingNewMessages)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_NcLoadingIcon, { size: 20 }),
                        _createTextVNode(" " + _toDisplayString($options.t('spreed', 'Loading …')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 64))
  ], 34))
}